import React, { Suspense } from 'react';
import { Spin } from 'antd';
import { retry } from './retry';

type Loader = () => Promise<{ default: React.ComponentType }>;
export const LazyLoader = ({ loader }: { loader: Loader }) => {
	const Component = React.lazy(() => retry(loader));
	return (
		<Suspense fallback={<Spin />}>
			<Component />
		</Suspense>
	);
};
